import { PipeTransform, Pipe } from '@angular/core';
 import { AccountInfoModelList } from '@app/models/account-info/myAccountInfoModel';
import { MerchantProfileModel } from '@app/models/merchant-profile-model/merchant-profile-model';
import { MerchantSettlementListModel, MerchantSettlementModel } from '@app/models/merchant-settlement-model/merchant-settlement-model';
import { FleetCardList } from '@app/models/multipleCardFundAllocateModel';

@Pipe({
    name: 'cardfilter'
})
export class CardFilterPipe implements PipeTransform {
    transform(items: MerchantSettlementModel[], searchTerm: string): MerchantSettlementModel[] {
        if (!items || !searchTerm) {
            return items;
        }
        return items.filter(item =>{
          
                if(item.SettlementDate.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
                {
                    return true;
                }
                if(item.SettlementId !== -1)
                {
                    return true;
                }
                if(item.TerminalNumber.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
                {
                    return true;
                }
                if(item.BatchId.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
                {
                    return true;
                }
                if(item.CutOffDate.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
                {
                    return true;
                }
                if(item.Method.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
                {
                    return true;
                }
        })
            //item.CardNumber.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }    
}

@Pipe({
    name: 'cardFilterForFundAllocation'
})
export class CardFilterFundAllocationPipe implements PipeTransform {
    transform(items: FleetCardList[], searchTerm: string): FleetCardList[] {
        if (!items || !searchTerm) {
            return items;
        }
        return items.filter(item =>{
          
                if(item.CardNumber.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1)
                {
                    return true;
                }
               
        })
            //item.CardNumber.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1);
    }    
}




// WEBPACK FOOTER //
// ./src/app/pipes/searchCardFilter.pipe.ts